import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faCheckCircle, faCircle, faStar, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { useResponsiveStyles } from './useResponsiveStyles';


const ListGroupCard = ({ title, items, styles = {}, template = "Default" }) => {

    const appliedStyles = useResponsiveStyles(styles);


    // Map string keys to FontAwesome icon definitions
    const iconMap = {
        faAngleRight: faAngleRight,
        faCheckCircle: faCheckCircle,
        faCircle: faCircle,
        faStar: faStar,
        faArrowRight: faArrowRight,
    };

    const renderItems = (defaultIcon) =>
        items.map((item, index) => {
            const itemIcon = typeof item.icon === 'string' ? iconMap[item.icon] : defaultIcon; // Map string to icon
            const itemText = typeof item === 'string' ? item : item.text; // Support plain strings for backward compatibility

            return (
                <li
                    key={index}
                    className="list-group-item align-items-center"
                    style={appliedStyles.item}
                >
                    {itemIcon && <FontAwesomeIcon icon={itemIcon} style={appliedStyles.icon} />}
                    {itemText && <span style={{  }}>{itemText}</span>}
                </li>
            );
        });

    switch (template) {
        case "Outlined":
            return (
                <div className="card outlined-list-group" style={appliedStyles.container}>
                    <div className="card-header" style={appliedStyles.header}>{title}</div>
                    <ul className="list-group list-group-flush">{renderItems(iconMap.faCheckCircle)}</ul>
                </div>
            );

        case "Gradient":
            return (
                <div className="card gradient-list-group" style={appliedStyles.container}>
                    <div className="card-header text-white" style={appliedStyles.header}>{title}</div>
                    <ul className="list-group list-group-flush">{renderItems(iconMap.faStar)}</ul>
                </div>
            );

        case "Minimal":
            return (
                <div className="card minimal-list-group" style={appliedStyles.container}>
                    <div className="card-header" style={appliedStyles.header}>{title}</div>
                    <ol className="list-group">{renderItems(iconMap.faCircle)}</ol>
                </div>
            );

        case "IconOnly":
            return (
                <div className="card icon-only-list-group" style={appliedStyles.container}>
                    <ul className="list-group">{renderItems(iconMap.faArrowRight)}</ul>
                </div>
            );

        default:
            return (
                <div className="card default-list-group" style={appliedStyles.container}>
                    <div className="card-header" style={appliedStyles.header}>{title}</div>
                    <ul className="list-group list-group-flush">{renderItems(iconMap.faAngleRight)}</ul>
                </div>
            );
    }
};

export default ListGroupCard;
